import {inject} from '@angular/core';
import {map} from 'rxjs';
import {AuthService} from '../../../services/auth.service';
import {CanActivateFn, Router} from '@angular/router';

export const AuthGuard: CanActivateFn = (route, state) => {
    const authService = inject(AuthService);
    const router = inject(Router);
    return authService.isAuthenticated().pipe(map((authenticated)=>{
        if (authenticated) {
            return true;
        }
        // Store the attempted URL for redirecting
        const redirectUrl = state.url;

        // Navigate to the login page with extras
        return router.createUrlTree(['/login'], {
            queryParams: { redirectURL: redirectUrl }
        });
    }))
};
